
import http from '@/utils/http';

export const fetchStreamingKOLPage: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/streamingKolRank',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
}
